import Vue from 'vue'; // 导入 Vue

// 创建响应式对象（替代原有的普通变量）
const state = Vue.observable({
  profileCache: null
});

export default {
  setProfile(profile) {
    state.profileCache = profile; // 更新响应式数据
  },
  getProfile() {
    return state.profileCache; // 返回响应式数据
  },
  clearProfile() {
    state.profileCache = null;
  }
};
